import React from 'react';
import '../assets/styles/startgame.css';
import { useNavigate, useParams } from 'react-router-dom';

export default function StartGames() {
    const navigate = useNavigate();
    const { day } = useParams();
    const handleBackClick = () => {
        navigate(`/menu/${day}`);
    };
    return (
        <div className="games-page">
        <div className="header">
        <div className="back-button" onClick={() => handleBackClick()}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M15 18L9 12L15 6" stroke="#CCA4CC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
            <h1 className="title">Games</h1>
        </div>
        <div className="content">
            <h2 className="subtitle">Start Your Winning Journey Today !</h2>
            <button className="play-button" onClick={() => navigate(`/games/${day}`)}>Play now</button>
        </div>
        </div>
    );
}
